// src/context/LoaderContext.js
"use client";
import { createContext, useContext, useEffect, useState } from "react";
import emitter, { LOADER_EVENTS } from "@/utils/loaderEvents";

const LoaderContext = createContext({ isLoading: false });

export const LoaderProvider = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0);

useEffect(() => {
  const handleStart = () => {
    // console.log("🟡 Event: START");
    setLoadingCount((c) => c + 1);
  };
  const handleStop = () => {
    // console.log("🟢 Event: STOP");
    setLoadingCount((c) => Math.max(0, c - 1));
  };

  emitter.on(LOADER_EVENTS.START, handleStart);
  emitter.on(LOADER_EVENTS.STOP, handleStop);

  return () => {
    emitter.off(LOADER_EVENTS.START, handleStart);
    emitter.off(LOADER_EVENTS.STOP, handleStop);
  };
}, []);

  return (
    <LoaderContext.Provider value={{ isLoading: loadingCount > 0 }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useGlobalLoader = () => useContext(LoaderContext);
